import { render, staticRenderFns } from "./package-component.vue?vue&type=template&id=f3b77ec8&scoped=true"
import script from "./package-component.vue?vue&type=script&lang=ts"
export * from "./package-component.vue?vue&type=script&lang=ts"
import style0 from "./package-component.vue?vue&type=style&index=0&id=f3b77ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b77ec8",
  null
  
)

export default component.exports